
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Login from './components/Dashboard/Login';
import Dashboard from "./components/Dashboard/Dashboard";
import PrivateRoute from './components/Dashboard/PrivateRoute';
import { AuthProvider } from './components/context/AuthContext';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 
function App() {
    useEffect(() => {
  // Apply theme before any content renders using sessionStorage
  const savedTheme = sessionStorage.getItem("selectedTheme") || "template2";
   const themes = ["template1", "template2","template3","template4","template5"];
  document.body.classList.remove(...themes.map((t) => `theme-${t}`));
  document.body.classList.add(`theme-${savedTheme}`);
}, []);
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    {/* Protect all other routes */}
                    <Route path="/*" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                </Routes>
                <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
            </AuthProvider>
        </Router>
    );
}
 
export default App;